<template>
	<div class="main">
		<div class="content">
			<div class="main-content">
				<div class="time-container">
					<h2>Today</h2>
					<p class="time" v-if="hour">
						{{ hour }}<span id="dot">:</span>{{ mins
						}}<span class="amPm">{{ amPm }}</span>
					</p>
					<p v-if="date" class="date">{{ date }}</p>
				</div>

				<div class="selected-date-container">
					<h2>Select Date</h2>

					<input type="date" placeholder="Date" v-model="selectedDate" />
				</div>
				<p v-if="selectedDateString">{{ selectedDateString }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, onUnmounted, ref, watch } from "vue";
import moment from "moment";
import { computed } from "@vue/reactivity";

export default {
	props: ["updateLoading"],
	setup(props) {
		const selectedDate = ref();
		const ngboDay = ref();
		const igboDay = ref();
		const date = ref();
		const hour = ref();
		const mins = ref();
		const amPm = ref();
		const timer = ref();
		const selectedDateString = ref();

		const onChange = (dateString) => {
			let { ngbo, igbo } = getLocalDay(dateString);
			ngboDay.value = ngbo;
			igboDay.value = igbo;
		};

		const getLocalDay = (date) => {
			const days = ["Owokwo", "Okwo", "Azokwo", "Unugwe", "Ekoshi"];
			const days2 = ["Nkwo", "Eke", "Orie", "Afor"];

			// Initialize date object
			let date1 = new Date("2023-04-01");
			let date2 = new Date(date);

			// Conversion to milliseconds
			const oneDay = 24 * 60 * 60 * 1000; // one day in milliseconds
			const diffInMilliseconds = date2 - date1;

			let ngbo;
			let igbo;
			let diffInDays;

			if (diffInMilliseconds < 0) {
				// Past Date
				diffInDays = Math.round(Math.abs(diffInMilliseconds / oneDay));
				let ngboDayOffset = Math.round(diffInDays % 5) || 5;
				ngbo = days[days.length - ngboDayOffset];

				let igboDayOffset = Math.round(diffInDays % 4) || 4;
				igbo = days2[days2.length - igboDayOffset];
				return { ngbo, igbo };
			} else {
				// Future Date
				diffInDays = Math.round(diffInMilliseconds / oneDay);
				ngbo = days[diffInDays % 5];
				igbo = days2[diffInDays % 4];
				return { ngbo, igbo };
			}
		};

		const time = () => {
			const date = new Date();

			const hours = date.getHours();

			hour.value = hours % 12 ? `${hours % 12}`.padStart(2, "0") : 12;
			const minutes = date.getMinutes();
			mins.value = minutes.toString().padStart(2, 0);
			amPm.value = hours >= 12 ? "PM" : "AM";
		};

		watch(selectedDate, () => {
			if (!selectedDate.value) {
				selectedDateString.value = "";
				return;
			}
			onChange(selectedDate.value);
			selectedDateString.value = `${ngboDay.value}, ${igboDay.value}, ${moment(
				selectedDate.value
			).format("dddd, MMMM Do YYYY")}`;
		});

		onMounted(() => {
			props.updateLoading(true);
			// Get date in YYYY-MM-DD
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, "0");
			const day = String(today.getDate()).padStart(2, "0");
			const currentDate = year + "-" + month + "-" + day;

			// Initializing the function to get date in ngbo and igbo
			onChange(currentDate);

			// Initializing interval for time
			timer.value = setInterval(time, 1000);

			//Set date to current date
			date.value = `${ngboDay.value}, ${igboDay.value}, ${moment().format(
				"dddd, MMMM Do YYYY"
			)}`;

			props.updateLoading(false);
		});

		// Clear interval when unmounted
		onUnmounted(() => {
			clearInterval(timer.value);
			timer.value = null;
		});

		return {
			onChange,
			selectedDate,
			ngboDay,
			igboDay,
			date,
			hour,
			mins,
			amPm,
			selectedDateString,
		};
	},
};
</script>

<style scoped>
.main {
	height: 100%;
	background-color: #000;
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: #fff;
}

.main-content {
	display: flex;
	flex-direction: column;
	gap: 30px;
	width: fit-content;
}

.datepicker {
	outline: none;
}

.time-container {
	display: flex;
	flex-direction: column;
}

.selected-date-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

h2 {
	font-weight: bold;
	color: #ca2c92;
}

.time {
	font-size: 45px;
}

.amPm {
	font-size: 12px;
}

input {
	outline: none;
	padding: 10px;
	border-radius: 8px;
	border: 1px solid grey;
	color: black;
}

@keyframes dot {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}

#dot {
	animation: dot 1.3s ease infinite;
}
</style>
